import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/token.svg'
import _imports_1 from '@/assets/icons/select.svg'


const _withScopeId = n => (_pushScopeId("data-v-66cabf3b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative flex flex-col items-center" }
const _hoisted_2 = {
  key: 0,
  class: "validation-err text-red-500 text-xs w-full"
}
const _hoisted_3 = { class: "bg-black bg-opacity-50 rounded-lg p-2" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  src: _imports_0,
  class: "h-6"
}
const _hoisted_6 = { class: "ml-2" }
const _hoisted_7 = { class: "flex flex-row items-center h-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "ml-1"
}, null, -1 /* HOISTED */))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Balance unavailable")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Select origin network to view balance ")
const _hoisted_13 = { class: "relative" }
const _hoisted_14 = {
  key: 0,
  class: "text-center text-red-500 flex flex-col"
}
const _hoisted_15 = { class: "text-center opacity-70" }
const _hoisted_16 = {
  key: 0,
  class: "uppercase"
}
const _hoisted_17 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_text = _resolveComponent("n-text")!
  const _component_n_tooltip = _resolveComponent("n-tooltip")!
  const _component_token_select = _resolveComponent("token-select")!
  const _component_n_input = _resolveComponent("n-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" token select/display "),
    _createCommentVNode(" TODO: make into token component, incorporate in token select modal "),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "flex flex-grow flex-row justify-center items-center mt-6 cursor-pointer relative",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (this.showTokenSelect = !this.showTokenSelect))
      }, [
        (_ctx.v$.token.$invalid)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, " * required "))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_3, [
          (this.token.icon)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: this.token.icon,
                class: "h-6"
              }, null, 8 /* PROPS */, _hoisted_4))
            : (_openBlock(), _createElementBlock("img", _hoisted_5))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_n_text, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(this.token.symbol || 'Select token'), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            _hoisted_8
          ]),
          _createCommentVNode(" token balance, show if token selected "),
          (this.token.symbol)
            ? (_openBlock(), _createBlock(_component_n_text, {
                key: 0,
                class: "opacity-60 text-xs"
              }, {
                default: _withCtx(() => [
                  (_ctx.originNetwork)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, " Balance: " + _toDisplayString(_ctx.balance ? _ctx.toDecimals(_ctx.balance, _ctx.token.decimals, 6) : 0), 1 /* TEXT */))
                    : (_openBlock(), _createElementBlock("span", _hoisted_10, [
                        _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                          trigger: _withCtx(() => [
                            _hoisted_11
                          ]),
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]))
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _createCommentVNode(" token select modal "),
    _createVNode(_component_token_select, {
      show: _ctx.showTokenSelect,
      onSelectToken: _ctx.selectToken,
      onHide: _cache[1] || (_cache[1] = ($event: any) => (this.showTokenSelect = false))
    }, null, 8 /* PROPS */, ["show", "onSelectToken"]),
    _createCommentVNode(" amount "),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_n_input, {
        type: "number",
        ref: "amount",
        placeholder: "0.0",
        value: _ctx.amt,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.amt) = $event)),
        size: "large",
        autosize: "",
        style: {"min-width":"100px","max-width":"300px","min-height":"70px"},
        class: "input text-5xl overflow-visible font-extra-light bg-transparent outline-none text-center"
      }, null, 8 /* PROPS */, ["value"]),
      (_ctx.balance && _ctx.token.symbol && !_ctx.token.nativeOnly)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "capitalize absolute left-[100%] ml-2 h-full text-lg opacity-70",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.max && _ctx.max(...args)))
          }, " Max "))
        : _createCommentVNode("v-if", true)
    ]),
    _createCommentVNode(" amount errors "),
    (_ctx.v$.amt.$errors.length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.amt.$errors, (error, index) => {
            return (_openBlock(), _createElementBlock("span", {
              key: index,
              class: "error-msg"
            }, _toDisplayString(error.$message), 1 /* TEXT */))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createCommentVNode(" amount USD "),
          _createElementVNode("p", _hoisted_15, [
            (!_ctx.amt)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Enter Amount"))
              : (_ctx.token.coinGeckoId)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, "~ $" + _toDisplayString(_ctx.amtInUSD) + " USD", 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
          ])
        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
  ], 64 /* STABLE_FRAGMENT */))
}